/**
 * Cuentas de la paginación. Viven acá y no en el componente para que este
 * exporte solo la pieza visual, que es lo que el recarga-en-caliente de Vite
 * necesita para no perder el estado de la pantalla en cada edición.
 */

/** Cuántas páginas hacen falta para `total` registros. */
export const totalDePaginas = (total: number, tamanio: number): number =>
  Math.max(1, Math.ceil(total / tamanio));

/**
 * Encierra la página dentro de lo que existe.
 *
 * Hace falta porque la lista cambia debajo: al destildar un concepto la tabla
 * se achica, y quien estaba en la última página se quedaba mirando una tabla
 * vacía.
 */
export const paginaValida = (pagina: number, total: number, tamanio: number): number =>
  Math.min(Math.max(1, pagina), totalDePaginas(total, tamanio));
